import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getAllUserRoles } from "../server/rolesAllApi";
import { Snackbar, Alert, CircularProgress } from "@mui/material";

const EditFreeCourseCommunity = () => {
  const [formValues, setFormValues] = useState({
    title: "",
    community_link: "",
    role_id: "",
  });
  const location = useLocation();
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const communityToEdit = location.state?.item;

  useEffect(() => {
    if (communityToEdit) {
      // console.log("traderrrrrr info: ", communityToEdit);

      setFormValues({
        title: communityToEdit?.title,
        community_link: communityToEdit?.link_url,
        role_id: communityToEdit?.role_id,
      });
      setLoading(false); // Stop loading after setting form state
    } else {
      setError("No tutor data found.");
      setLoading(false);
    }
  }, [communityToEdit]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [touched, setTouched] = useState(false);
  const [roles, setRoles] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserRoles = async () => {
      setLoading(true);
      setError(null);
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }
      try {
        const reqHeader = { authorization: `Bearer ${token}` };
        const response = await getAllUserRoles("", reqHeader);
        setRoles(response.data.roles);
      } catch (error) {
        setError("Failed to fetch users.");
      } finally {
        setLoading(false);
      }
    };
    fetchUserRoles();
  }, []);

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }

      // console.log(
      //   "REACT_APP_INSTITUTION_BASEURL:: ",
      //   process.env.REACT_APP_INSTITUTION_BASEURL
      // );
      const response = await axios.put(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/edit-community/${communityToEdit._id}`,
        formValues,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        setSnackbarMessage("Updated successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        setTimeout(() => {
          navigate("/community-list");
        }, 2000);
      }
    } catch (err) {
      setLoading(false);

      // Check for 400 status error
      if (err.response && err.response.status === 400) {
        setSnackbarMessage("Please fill out all required fields...");
        setSnackbarSeverity("warning");
        setOpenSnackbar(true);
      } else {
        setSnackbarMessage("Failed to update. Please try again");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="row gy-4">
      <div className="col-lg-8" style={styles.cardContent(loading)}>
            <div className="card h-100">
              <div className="card-body p-24">
                <form onSubmit={handleFormSubmit}>
                  <div className="mb-20">
                    <label
                      htmlFor="title"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Title
                      <span className="text-danger-600">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control radius-8"
                      id="title"
                      required
                      placeholder="Enter Title"
                      value={formValues.title}
                      onChange={(e) => {
                    
                        const value = e.target.value;
    
                        if (value === "" || value.trim() !== "") {
                          setFormValues({
                            ...formValues,
                            title: value,
                          });
                        }
                      }}
                      onBlur={() => setTouched(true)} // Mark as touched when losing focus
                    />
                  </div>

                  <div className="mb-20">
                    <label
                      htmlFor="community_link"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      URL<span className="text-danger-600">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control radius-8"
                      id="community_link"
                      required
                      placeholder="Enter URL"
                      value={formValues.community_link}
                      onChange={(e) =>
                        {
                          const value = e.target.value;
                          if (value === "" || value.trim() !== "") {
                        setFormValues({
                          ...formValues,
                          community_link: e.target.value,
                        });
                      }}}
                    />
                  </div>
                  <div className="mb-20">
                    <label
                      htmlFor="role_id"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Role
                      <span className="text-danger-600">*</span>
                    </label>
                    <select
                      className="form-control radius-8 form-select"
                      id="role_id"
                      required
                      value={formValues.role_id}
                      onChange={(e) =>
                        setFormValues({
                          ...formValues,
                          role_id: e.target.value,
                        })
                      }
                    >
                      <option value="" disabled>
                        Select a Role
                      </option>
                      {roles.map((role) => (
                        <option key={role._id} value={role._id}>
                          {role.rolename}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="d-flex align-items-center justify-content-center gap-3">
                    <button
                      type="button"
                      className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8"
                      onClick={() => navigate("/community-list")}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                      // onClick={handleFormSubmit}
                    >
                      {loading && (
         <div className="loader-container" style={styles.loaderContainer}>
                                              <CircularProgress />
                                            </div>
                                          )}
                                            Save
                    </button>
                  </div>
                </form>
              </div>
            
        </div>
      </div>
      {/* snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          // variant="filled"
          // sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

// Add CSS for loader
const styles = {
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  cardContent: (loading) => ({
    opacity: loading ? 0.5 : 1,
  }),
};

export default EditFreeCourseCommunity;
